module.exports = __webpack_public_path__ + "static/media/resolve_case.604aef7b.png";